module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Lily-laughing-1280.ea5270fc.png";